import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { MultiItemStore } from 'stores/multi-item-store';

import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

import { BackLink } from 'components/infosite/property-details/components/back-link';
import { Breadcrumbs } from 'components/infosite/property-details/breadcrumbs';
import { FavoriteSaveButton } from 'components/infosite/property-details/information.tsx';
import { PropertySummaryHeader } from './property-summary-header';
import { ShareMenu } from './share/share-menu';

interface PropertySummaryBackLinkWrapperProps {
  regionId: string;
  currentHotel?: CurrentHotelStore;
  navigateTabs?: () => any;

  multiItem?: MultiItemStore;
}

export type LocalizedPropertySummaryBackLinkWrapperProps = LocalizedComponentProps & PropertySummaryBackLinkWrapperProps;

@withLocalization
@inject('currentHotel', 'multiItem')
@observer
export class PropertySummaryBackLinkWrapper extends React.Component<LocalizedPropertySummaryBackLinkWrapperProps> {
  public render() {
    const { currentHotel, multiItem, l10n } = this.props;

    const propertySearchLink = currentHotel.offers?.propertySearchLink;
    const partnerPropertySearchLink = currentHotel.offers?.partnerPropertySearchLink;
    const searchCriteria = currentHotel?.searchCriteria;
    const regionId = searchCriteria?.regionId;
    const startDate = searchCriteria?.startDate;
    const endDate = searchCriteria?.endDate;

    const isDateless = currentHotel?.searchCriteria?.isDateless;

    return (
      <>
        <Breadcrumbs breadcrumbsContent={currentHotel?.breadcrumbs} isDateless={isDateless} />
        <Viewport>
          <ViewSmall>
            <>
              <UitkSpacing padding={{ inline: 'two', blockend: 'two' }}>
                <div>
                  <PropertySummaryHeader l10n={l10n} multiItem={multiItem} regionId={regionId} startDate={startDate} endDate={endDate} />
                </div>
              </UitkSpacing>
              <UitkCardAloha className="uitk-flat-border-top uitk-flat-border-bottom" overflow={true}>
                <UitkCardAlohaContentSection padded={false}>
                  <UitkSpacing padding={{ block: 'one', inline: 'two' }}>
                    <div>
                      <UitkLayoutFlex alignItems="center" justifyContent="space-between">
                        <UitkLayoutFlexItem>
                          <BackLink
                            model={propertySearchLink || partnerPropertySearchLink}
                            useAbsolutePath={Boolean(partnerPropertySearchLink)}
                            forceRefresh={multiItem.isPackageShoppingPath()}
                          />
                        </UitkLayoutFlexItem>
                        <UitkLayoutFlexItem>
                          <UitkLayoutFlex>
                            <UitkLayoutFlexItem>
                              <ShareMenu />
                            </UitkLayoutFlexItem>
                            <UitkLayoutFlexItem>
                              <div data-stid="favorite-save-button">
                                <FavoriteSaveButton currentHotel={currentHotel} />
                              </div>
                            </UitkLayoutFlexItem>
                          </UitkLayoutFlex>
                        </UitkLayoutFlexItem>
                      </UitkLayoutFlex>
                    </div>
                  </UitkSpacing>
                </UitkCardAlohaContentSection>
              </UitkCardAloha>
            </>
          </ViewSmall>
          <ViewLarge>
            <UitkCardAloha className="uitk-flat-border-top uitk-flat-border-bottom" overflow={true}>
              <UitkCardAlohaContentSection padded={false}>
                <UitkSpacing padding={{ inline: 'two' }}>
                  <div>
                    <PropertySummaryHeader l10n={l10n} multiItem={multiItem} regionId={regionId} startDate={startDate} endDate={endDate} />
                  </div>
                </UitkSpacing>
                <UitkSpacing padding={{ block: 'two', inline: 'two' }}>
                  <div>
                    <UitkLayoutFlex alignItems="center" justifyContent="space-between">
                      <UitkLayoutFlexItem>
                        <BackLink
                          model={propertySearchLink || partnerPropertySearchLink}
                          useAbsolutePath={Boolean(partnerPropertySearchLink)}
                          forceRefresh={multiItem.isPackageShoppingPath()}
                        />
                      </UitkLayoutFlexItem>
                      <UitkLayoutFlexItem>
                        <UitkLayoutFlex>
                          <UitkLayoutFlexItem>
                            <ShareMenu />
                          </UitkLayoutFlexItem>
                          <UitkLayoutFlexItem>
                            <div data-stid="favorite-save-button">
                              <FavoriteSaveButton currentHotel={currentHotel} />
                            </div>
                          </UitkLayoutFlexItem>
                        </UitkLayoutFlex>
                      </UitkLayoutFlexItem>
                    </UitkLayoutFlex>
                  </div>
                </UitkSpacing>
              </UitkCardAlohaContentSection>
            </UitkCardAloha>
          </ViewLarge>
        </Viewport>
      </>
    );
  }
}
